var LeafletControlLayersConfig = /** @class */ (function () {
    function LeafletControlLayersConfig() {
        this.baseLayers = {};
        this.overlays = {};
    }
    return LeafletControlLayersConfig;
}());
export { LeafletControlLayersConfig };
//# sourceMappingURL=leaflet-control-layers-config.model.js.map